import { type AsyncResult, Err, Ok } from '@visiba/react-std';
import { isBoolean, isError, isFunction, isPromise, isResultType, isString } from '@visiba/std';

export const UNSPECIFIED_ERROR = 'UNSPECIFIED_ERROR';

export async function unwrapError(someError: unknown): Promise<string> {
	let someUnwrappedValue: unknown = someError;

	if (isFunction(someUnwrappedValue)) {
		someUnwrappedValue = someUnwrappedValue();
	}

	if (isPromise(someUnwrappedValue)) {
		someUnwrappedValue = await someUnwrappedValue;
	}

	if (isResultType(someUnwrappedValue)) {
		someUnwrappedValue = someUnwrappedValue.err;
	}

	if (isError(someUnwrappedValue)) {
		someUnwrappedValue = someUnwrappedValue.message || UNSPECIFIED_ERROR;
	}

	return isString(someUnwrappedValue) ? someUnwrappedValue : UNSPECIFIED_ERROR;
}

export async function unwrapCallbackValue(someValue: unknown): AsyncResult<boolean, string> {
	try {
		let someUnwrappedValue: unknown = someValue;
		if (isPromise(someUnwrappedValue)) {
			someUnwrappedValue = await someUnwrappedValue;
		}

		if (isResultType(someUnwrappedValue)) {
			if (someUnwrappedValue.err) {
				// @ts-ignore -- Unsure how to fix in this PR, feel free to fix
				return Err(await unwrapError(someUnwrappedValue.err));
			}

			someUnwrappedValue = someUnwrappedValue.ok;
		}

		if (isBoolean(someUnwrappedValue)) {
			// If the result of all this discovery work is a falsy boolean value,
			// we should not reset the form state.
			if (!someUnwrappedValue) {
				return Ok(false);
			}
		}
	} catch (error) {
		// @ts-ignore -- Unsure how to fix in this PR, feel free to fix
		return Err(await unwrapError(error));
	}

	return Ok(true);
}
